import { Subject, BehaviorSubject } from 'rxjs';
import { CodePricesResponse, CodesPricesRequest } from '@jms/model';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

export class CodePriceSearcher {
    protected _searchSubject = new Subject<CodesPricesRequest>();
    public data$ = new BehaviorSubject<CodePricesResponse[]>([]);

    constructor(public http: HttpClient, public endPoint: string,) {
        this._searchSubject
            .subscribe(data => {
                this.getData(data);
            });
    }

    public search(request?: CodesPricesRequest) {
        this._searchSubject.next(request);
    }

    public getData(request?: CodesPricesRequest) {
        this.http
            .post<CodePricesResponse[]>(this.endPoint, request)
            .pipe(
                map(prices => this.data$.next(prices)),
                catchError(x => {
                    return null;
                })
            )
            .subscribe();
    }
}
